import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks/useSonarSelector';
const selector = createSonarSelector((state) => { var _a; return Boolean((_a = state.application.maintenance.read.data) === null || _a === void 0 ? void 0 : _a.locked); });
export function useMaintenanceMode() {
    return useSonarSelector(selector);
}
